@if(contextualInfoDisplay?.length){
  <div class="sx-help-contextual-info">
    @for(contextualInfo of contextualInfoDisplay; track contextualInfo;){
      <div>
        <div class="sx-help-contextual-info__title">
          {{ contextualInfo.title }}
        </div>
        @if(contextualInfo?.description) {
          <div appRouterLink class="sx-help-contextual-info__description" [innerHtml]="contextualInfo.description | safeHtml">
          </div>
        }
      </div>
    }
  </div>
}
